import { render, staticRenderFns } from "./AirdropSummary.vue?vue&type=template&id=22722d08&scoped=true&"
import script from "./AirdropSummary.vue?vue&type=script&lang=js&"
export * from "./AirdropSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22722d08",
  null
  
)

export default component.exports